import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { message } from 'antd';
import localForage from 'localforage';
import MuiButton from 'material-ui/Button';

import BizCard from '../../components/UI/BizCard';
import BizInput from '../../components/UI/BizInput';
import FormFloatingButtons from '../../components/FormFloatingButtons';

import LcsFis from './LcsFis';

import MUTATION from '../../graphql/mutations/leadConversionSheetMutation.graphql';

const localForageItemkey = (cid) => (`${cid}_lcs`);

const initialState = ({ companyName }) => ({
  companyName,
  termsAgreed: '',
  termsOfNegotiation: '',
  justification: '',
  expectedOtherBusiness: '',
  startedAt: new Date().toISOString(),
});

class LeadConversionSheetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState(props),
    };
  }

  componentDidMount() {
    localForage.getItem(localForageItemkey(this.props.match.params.cid))
      .then((value) => {
        if (value) {
          this.setState({
            ...value,
          });
        }
      });
  }

  clearForm = () => {
    localForage.removeItem(localForageItemkey(this.props.match.params.cid));
    this.setState({
      ...initialState(this.props),
    });
  };

  saveData = () => {
    const { ...data } = this.state;
    localForage.setItem(localForageItemkey(this.props.match.params.cid), data)
      .then(() => {
        message.success('Saved!');
      })
      .catch(() => {
        message.error('Not Saved!');
      });
  };

  handleFormValue = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  handleFormSubmit = () => {
    const customerId = this.props.match.params.cid;

    this.props.mutate({
      variables: {
        customerId,
        ...this.state,
      },
    })
      .then(() => {
        message.success('Success!');
        this.clearForm();
        // this.props.history.push(`/app/lead/${customerId}`);
      })
      .catch((mutateErr) => {
        message.error(mutateErr.message);
      });
  };

  render() {
    const {
      companyName,
      termsAgreed,
      termsOfNegotiation,
      justification,
      expectedOtherBusiness,
    } = this.state;

    const { lcsFis } = this.props;

    return (
      <div>
        {
          lcsFis ?
            <LcsFis lcsFis={lcsFis} />
            :
            null
        }
        <BizCard title="Lead Conversion Sheet">
          <FormFloatingButtons handleSave={this.saveData} handleClear={this.clearForm} />
          <table className="biz-form-table">
            <tbody>
              {/* Company Name */}
              <tr>
                <td className="biz-form-table-label">Company Name</td>
                <td className="biz-form-table-input">
                  <BizInput name="companyName" theme="lac" onChange={(value) => { this.setState({ companyName: value }); }} value={companyName} />
                </td>
                <td className="biz-form-table-action" />
              </tr>

              {/* Terms Agreed */}
              <tr>
                <td className="biz-form-table-label">Terms Agreed</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="termsAgreed"
                    onChange={(value) => { this.handleFormValue('termsAgreed', value); }}
                    value={termsAgreed}
                    style={{ width: '100%', height: 200, maxWidth: 'unset' }}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>

              {/* Terms Negotiation */}
              <tr>
                <td className="biz-form-table-label">If No, terms of negotiation</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="termsOfNegotiation"
                    onChange={(value) => { this.handleFormValue('termsOfNegotiation', value); }}
                    value={termsOfNegotiation}
                    style={{ width: '100%', height: 200, maxWidth: 'unset' }}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>

              {/* Justification */}
              <tr>
                <td className="biz-form-table-label">Justification</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="justification"
                    onChange={(value) => { this.handleFormValue('justification', value); }}
                    value={justification}
                    style={{ width: '100%', height: 200, maxWidth: 'unset' }}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>

              {/* Expected Other Business */}
              <tr>
                <td className="biz-form-table-label">Expected Other Business</td>
                <td className="biz-form-table-input">
                  <BizInput
                    type="textarea"
                    theme="lac"
                    name="expectedOtherBusiness"
                    onChange={(value) => { this.handleFormValue('expectedOtherBusiness', value); }}
                    value={expectedOtherBusiness}
                    style={{ width: '100%', height: 200, maxWidth: 'unset' }}
                  />
                </td>
                <td className="biz-form-table-action" />
              </tr>

              <tr>
                <td className="biz-form-table-label" />
                <td colSpan={2}>
                  <MuiButton variant="raised" color="primary" style={{ margin: '5px 0' }} onClick={this.handleFormSubmit}>
                    Submit
                  </MuiButton>
                </td>
              </tr>
            </tbody>
          </table>
        </BizCard>
      </div>
    );
  }
}

LeadConversionSheetForm.propTypes = {
  companyName: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cid: PropTypes.string.isRequired,
    }),
  }).isRequired,
  lcsFis: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  mutate: PropTypes.func.isRequired,
};

LeadConversionSheetForm.defaultProps = {
  lcsFis: null,
};

export default graphql(MUTATION)(LeadConversionSheetForm);



// WEBPACK FOOTER //
// ./src/pages/leads/LeadConversionSheetForm.jsx